import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { AutoComplete } from "antd";
import { toast } from "react-toastify";
import convertToExcel from "../../../../components/ExportToExcel";

const FarmerComplianceMaize = () => {
  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0.00";
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);

  const [seasonlist, setSeasonlist] = useState(null);
  const [seasonId, setSeasonId] = useState();
  const [cropId, setCropId] = useState("");
  const [cropFilterList, setCropFilterList] = useState([]);
  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);
  const [fieldName, setFieldName] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [employeeAllData, setEmployeeAllData] = useState([]);

  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [expandedGroups, setExpandedGroups] = useState({});
  useEffect(() => {
    const initialState = {};
    Object.keys(activityStructure).forEach((heading) => {
      initialState[heading] = true;
    });
    setExpandedGroups(initialState);
  }, [data]);
  const toggleGroup = (heading) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [heading]: !prev[heading],
    }));
  };

  const { sendRequest: getprocurementData } = useHttp();

  // const fillprocurementData = (e) => {
  //   if (e) e.preventDefault();

  //   var urlfilter = "";

  //   if (employeeId > 0) {
  //     urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
  //   }

  //   if (seasonId > 0) {
  //     urlfilter = urlfilter + `&seasonId=${seasonId}`;
  //   }

  //   if (ranchId > 0) {
  //     urlfilter = urlfilter + `&ranchId=${ranchId}`;
  //   }

  //   if (farmerNumber) {
  //     urlfilter = urlfilter + `&farmerNo=${farmerNumber}`;
  //   }

  //   var url = `/api/farmerNlcReport/?orgId=${localStorage.getItem(
  //     "orgId"
  //   )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

  //   getprocurementData(
  //     {
  //       url: url,
  //     },
  //     (data) => {
  //       setData(data);
  //     }
  //   );
  // };

  const fillprocurementData = (e) => {
    if (e) e.preventDefault();

    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }
    if (cropId !== "") {
      urlfilter = urlfilter + `&cropId=${cropId}`;
    }

    if (seasonId > 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }

    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }
    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }

    if (farmerNumber) {
      urlfilter = urlfilter + `&farmerNo=${farmerNumber}`;
    }

    var url = `/api/farmerScoreboardReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillprocurementData();
  }, [
    seasonId,
    employeeId,
    ranchId,
    fieldName,
    farmerNumber,
    cropId,
  ]);

  useEffect(() => {
    if (!ranchId) {
      setFieldOptions([]);
      return;
    }

    var urlfilter = `&ranchId=${ranchId}`;

    getprocurementData(
      {
        url: `/api/farmerScoreboardReport/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}${urlfilter}`,
      },
      (res) => {
        const reportData = res || [];

        const uniqueFields = [
          ...new Set(
            reportData
              .map((item) => item.plotCode)
              .filter(Boolean)
          ),
        ];

        const fieldList = uniqueFields.map((f) => ({
          plotCode: f,
        }));

        setFieldOptions(fieldList);
      }
    );
  }, [ranchId]);

  const farmerDetailHeaders = [
    "Date",
    "Farmer No",
    "Farmer Name",
    "Season Name",
    "Crop",
    "Field Name",
    "Plot Area",
    "Plot Size Unit",
    "Extension Officer",
  ];

  const farmerDetailFields = [
    "date",
    "farmerNo",
    "farmerName",
    "seasonName",
    "cropName",
    "plotCode",
    "plotArea",
    "plotSizeUnit",
    "executiveName"
  ];

  // -- Export Handler -----------------------------------
  const handleExportExcel = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }
    const filename = "FarmerComplianceReport.xlsx";

    // --------- Build dynamic header arrays -------------
    const sectionHeaderRow = [
      ...farmerDetailHeaders.map((_, i) => (i === 0 ? "Farmer Details" : "")),
      ...Object.entries(activityStructure).flatMap(([heading, subs]) =>
        subs.length > 0 ? [heading, ...Array(subs.length - 1).fill("")] : []
      ),
      "Total Score",
      "Percentage",
    ];

    const subHeaderRow = [
      ...farmerDetailHeaders,
      ...Object.entries(activityStructure).flatMap(([heading, subs]) => subs),
      "Total Score",
      "Percentage (%)",
    ];

    // ------------- Build worksheet rows ----------------
    const exportRows = data.map((itm) => {
      // Farmer details
      const base = farmerDetailFields.map((f) => itm[f] ?? "-");

      // Dynamic activities
      const dyn = [];
      Object.entries(activityStructure).forEach(([heading, subs]) => {
        let ratingLabels = [];
        // special logic: "Planting" column should find from "Farm Management" activities
        if (heading === "Planting") {
          const farmAct = itm.activities?.find(
            (a) => a.mainHeading === "Farm Management"
          );
          ratingLabels = farmAct?.subHeadings || [];
          subs.forEach((subLabel, idx) => {
            const plantingMatch = ratingLabels.find(
              (r) => (r.activity || "").trim().toLowerCase() === "planting"
            );
            dyn.push(plantingMatch?.ratingLabel ?? "-");
          });
        } else {
          const act = itm.activities?.find((a) => a.mainHeading === heading);
          ratingLabels = act?.subHeadings || [];
          subs.forEach((subLabel, idx) => {
            let ratingLabel = "-";
            if (heading === "Farm Management") {
              const match = ratingLabels.find(
                (r) =>
                  (r.activity || "").trim().toLowerCase() ===
                  (subLabel || "").trim().toLowerCase()
              );
              ratingLabel = match?.ratingLabel ?? "-";
            } else {
              ratingLabel = ratingLabels[idx]?.ratingLabel ?? "-";
            }
            dyn.push(ratingLabel);
          });
        }
      });

      // Score and percentage
      return [...base, ...dyn, itm.totalScore ?? "-", itm.percentage ?? "-"];
    });

    // ---------- Calculate header merges dynamically -----
    let merges = [];
    // Farmer Details (A1:H1) if 8 columns
    if (farmerDetailHeaders.length > 1)
      merges.push({
        s: { r: 0, c: 0 },
        e: { r: 0, c: farmerDetailHeaders.length - 1 },
      });
    let colOffset = farmerDetailHeaders.length;
    Object.entries(activityStructure).forEach(([heading, subs]) => {
      if (subs.length === 1) {
        merges.push({ s: { r: 0, c: colOffset }, e: { r: 1, c: colOffset } });
        colOffset += 1;
      } else if (subs.length > 1) {
        merges.push({
          s: { r: 0, c: colOffset },
          e: { r: 0, c: colOffset + subs.length - 1 },
        });
        colOffset += subs.length;
      }
    });
    // Total Score & Percentage columns
    merges.push({ s: { r: 0, c: colOffset }, e: { r: 1, c: colOffset } });
    merges.push({
      s: { r: 0, c: colOffset + 1 },
      e: { r: 1, c: colOffset + 1 },
    });

    // ------------ Compose worksheet & export ------------
    const ws_data = [sectionHeaderRow, subHeaderRow, ...exportRows];

    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!merges"] = merges;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Compliance");
    XLSX.writeFile(wb, filename);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);


  const { sendRequest: getSeason } = useHttp();
  useEffect(() => {
    getSeason(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setSeasonlist(data);
      }
    );
  }, [getSeason]);

  //   const activityStructure = {};

  //   data?.forEach((item) => {
  //     item.activities?.forEach((act) => {
  //       const key = act.mainHeading;

  //       if (!activityStructure[key]) {
  //         activityStructure[key] = [];
  //       }

  //       act.subHeadings.forEach((sub, idx) => {
  //         const label =
  //           act.mainHeading === "Farm Management"
  //             ? sub.activity // use activity name like Sowing
  //             : `${key} ${idx + 1}`; // otherwise, use heading 1, 2

  //         if (!activityStructure[key].includes(label)) {
  //           activityStructure[key].push(label);
  //         }
  //       });
  //     });
  //   });

  let activityStructure = {};

  // Build the structure
  data?.forEach((item) => {
    item.activities?.forEach((act) => {
      let key = act.mainHeading;

      act.subHeadings.forEach((sub, idx) => {
        let label =
          act.mainHeading === "Farm Management"
            ? sub.activity
            : `${key} ${idx + 1}`;

        // ✅ Move Planting out of Farm Management
        if (act.mainHeading === "Farm Management" && label === "Planting") {
          if (!activityStructure["Planting"]) {
            activityStructure["Planting"] = [];
          }
          if (!activityStructure["Planting"].includes("Planting")) {
            activityStructure["Planting"].push("Planting");
          }
        } else {
          if (!activityStructure[key]) {
            activityStructure[key] = [];
          }
          if (!activityStructure[key].includes(label)) {
            activityStructure[key].push(label);
          }
        }
      });
    });
  });

  // ✅ Force EXACT column sequence
  const desiredOrder = [
    "Planting",
    "Fertilizer",
    "Weeding",
    "Spraying",
    "Farm Management",
  ];

  // Rebuild in exact order (ignore anything else not in list)
  activityStructure = desiredOrder.reduce((acc, key) => {
    if (activityStructure[key]) {
      acc[key] = activityStructure[key];
    }
    return acc;
  }, {});

  // ✅ Reorder so Planting comes first
  if (activityStructure["Planting"]) {
    const { Planting, ...rest } = activityStructure;
    activityStructure = { Planting, ...rest };
  }

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  const { sendRequest: getCropList } = useHttp();

  useEffect(() => {
    getCropList(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        console.log("Crop API Full Response:", res);
        setCropFilterList(res?.output);
      }
    );
  }, [getCropList]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }


    getFarmerNumber(
      {
        url: `/api/complainceFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);


  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  const filteredOptions =
    farmerData && farmerData
      ? farmerData
        .map((item) => item.farmerNo)
        .filter((no) => no.toLowerCase().includes(farmerNumber.toLowerCase()))
        .map((no) => ({ value: no }))
      : [];

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Farmer Compliance</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <section className="content">
          {" "}
          <form onSubmit={fillprocurementData}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Crop Name</label>
                    <select
                      id="cropNameId"
                      className="form-control"
                      value={cropId}
                      onChange={(e) => {
                        setCropId(e.target.value);
                        setData([]);
                      }}
                    >
                      <option value="">Select</option>

                      {cropFilterList &&
                        cropFilterList.map((x) => (
                          <option key={x.CropId} value={x.CropId}>
                            {x.CropName}
                          </option>
                        ))}
                    </select>

                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Season</label>
                    <select
                      id="season"
                      className="form-control"
                      value={seasonId}
                      onChange={(e) => {
                        setSeasonId(e.target.value || 0);

                      }}
                    // required
                    >
                      <option value="">Select</option>
                      {seasonlist &&
                        seasonlist.map((x) => (
                          <option key={x.seasonId} value={x.seasonId}>
                            {x.seasonName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>Ranch</label>
                    <select
                      id="ranch"
                      className="form-control"
                      value={ranchId}
                      onChange={(e) => {
                        setRanchId(e.target.value || 0);
                        setFieldName("");
                        setData([]);
                      }}
                    >
                      <option value="">Select</option>
                      {ranchData &&
                        ranchData.map((x) => (
                          <option key={x.ranchId} value={x.ranchId}>
                            {x.ranchName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>Field Name</label>
                    <select
                      className="form-control"
                      value={fieldName}
                      onChange={(e) => {
                        setFieldName(e.target.value);
                      }}
                    >
                      <option value="">Select</option>

                      {fieldOptions.map((x, i) => (
                        <option key={i} value={x.plotCode}>
                          {x.plotCode}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* <div className="col-md-3">
                  <div className="form-group">
                    <label>Field Officer</label>
                    <select
                      id="emp_id"
                      className="form-control"
                      ref={(el) => (frmRef.current["emp_id"] = el)}
                      value={employeeId}
                      onChange={(e) => {
                        setEmployeeId(e.target.value || 0);
                        setData([]);
                      }}
                    >
                      <option value={0}>Select</option>
                      {employeeData &&
                        employeeData.map((x) => (
                          <option
                            key={x.userId}
                            user-id={x.userId}
                            value={x.userId}
                          >
                            {x.employeeName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div> */}
                <div className="col-md-3">
                  <label htmlFor="farmer_number">Farmer Number</label>
                  <AutoComplete
                    className="form-control"
                    style={{ height: "30px" }}
                    value={farmerNumber}
                    options={filteredOptions}
                    placeholder="Farmer Number"
                    onChange={(value) => setFarmerNumber(value)}
                    onSelect={(value) => setFarmerNumber(value)}
                  />
                </div>

                <div className="col-md-2">
                  <div className="form-group">
                    <label>&nbsp;</label>
                    <button className="form-control btn btn-sm btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </div>{" "}
            </div>{" "}
          </form>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {currentItems.length > 0 ? (
                    <>
                      <div className="card-body">
                        <table className="table table-bordered table-responsive text-center">
                          <thead>
                            {/* Header Row 1 */}
                            <tr className="tableheaderrowview">
                              <th colSpan={7}>Farmer Details</th>

                              {Object.entries(activityStructure).map(
                                ([heading, subs]) => (
                                  <th
                                    key={heading}
                                    colSpan={
                                      expandedGroups[heading] ? subs.length : 1
                                    }
                                    style={{ cursor: "pointer" }}
                                    onClick={() => toggleGroup(heading)}
                                  >
                                    {heading}{" "}
                                    {expandedGroups[heading] ? "-" : "+"}
                                  </th>
                                )
                              )}

                              <th rowSpan={2}>Total Score</th>
                              <th rowSpan={2}>Percentage</th>
                            </tr>

                            {/* Header Row 2 */}
                            <tr className="table-subheader">
                              <th>Date</th>
                              <th>Farmer No</th>
                              <th>Farmer Name</th>
                              <th>Season Name</th>
                              <th>Crop</th>
                              <th>Field Name</th>
                              <th>Plot Area</th>
                              <th>Plot Size Unit</th>

                              {Object.entries(activityStructure).flatMap(
                                ([heading, subs]) =>
                                  expandedGroups[heading]
                                    ? subs.map((subLabel, idx) => (
                                      <th key={`${heading}_${idx}`}>
                                        {subLabel}
                                      </th>
                                    ))
                                    : [<th key={`${heading}_collapsed`}>-</th>]
                              )}
                            </tr>
                          </thead>

                          <tbody>
                            {currentItems.map((itm, i) => (
                              <tr key={i}>
                                {/* Farmer details */}
                                <td>{itm.date}</td>
                                <td>{itm.farmerNo}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.seasonName}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.plotCode}</td>
                                <td>{formatNumber(itm.plotArea)}</td>
                                <td>{itm.plotSizeUnit}</td>

                                {/* Activities */}
                                {Object.entries(activityStructure).flatMap(
                                  ([heading, subs]) => {
                                    if (heading === "Planting") {
                                      if (expandedGroups[heading]) {
                                        const farmManagement =
                                          itm.activities?.find(
                                            (a) =>
                                              a.mainHeading ===
                                              "Farm Management"
                                          );
                                        const planting =
                                          farmManagement?.subHeadings?.find(
                                            (s) =>
                                              s.activity
                                                ?.trim()
                                                .toLowerCase() === "planting"
                                          );
                                        const value =
                                          planting?.ratingLabel ?? "-";
                                        return (
                                          <td key={`planting_${i}`}>{value}</td>
                                        );
                                      } else {
                                        // When collapsed, just show "-"
                                        return (
                                          <td key={`planting_${i}`}>{"-"}</td>
                                        );
                                      }
                                    }

                                    const act = itm.activities?.find(
                                      (a) => a.mainHeading === heading
                                    );
                                    const ratingLabels = act?.subHeadings || [];

                                    if (expandedGroups[heading]) {
                                      // Expanded → show each subheading value
                                      return subs.map((subLabel, idx) => {
                                        let ratingLabel = "-";

                                        if (heading === "Farm Management") {
                                          const match = ratingLabels.find(
                                            (r) => r.activity === subLabel
                                          );
                                          ratingLabel =
                                            match?.ratingLabel ?? "-";
                                        } else {
                                          ratingLabel =
                                            ratingLabels[idx]?.ratingLabel ??
                                            "-";
                                        }

                                        // Check if numeric
                                        const isNumeric =
                                          !isNaN(parseFloat(ratingLabel)) &&
                                          isFinite(ratingLabel);

                                        return (
                                          <td key={`${i}_${heading}_${idx}`}>
                                            {isNumeric
                                              ? formatNumber(ratingLabel)
                                              : ratingLabel}
                                          </td>
                                        );
                                      });
                                    } else {
                                      // Collapsed: do not show any data, show "-"
                                      return (
                                        <td key={`${i}_${heading}_collapsed`}>
                                          {"-"}
                                        </td>
                                      );
                                    }
                                  }
                                )}

                                {/* Totals */}
                                <td>{formatNumber(itm.totalScore)}</td>
                                <td>{formatNumber(itm.percentage)}%</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="card-footer clearfix">
                        <Pagination
                          totalItems={data.length}
                          itemsPerPage={itemsPerPage}
                          onPageChange={paginate}
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                        />
                      </div>
                    </>
                  ) : (
                    <p className="text-center">No data available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerComplianceMaize;
